import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import TopNavBar from '@/components/TopNavBar';
import CommandCenter from '@/pages/CommandCenter';
import Fleet from '@/pages/Fleet';
import IframeModule from '@/pages/IframeModule';
import ComingSoon from '@/pages/ComingSoon';
import { UserRole } from '@/types';
import { useAuthUser } from '@/auth/AuthProvider';

function App() {
  const [currentRole, setCurrentRole] = useState<UserRole>('Executive');
  const authUser = useAuthUser();
  
  const user = {
    id: 'user-1',
    name: authUser?.name || 'User',
    email: authUser?.email || '',
    roles: ['Executive', 'IT/Dev'] as UserRole[],
    avatar: undefined as string | undefined,
  };

  const handleRoleChange = (role: UserRole) => {
    setCurrentRole(role);
  };

  return (
    <div className="min-h-screen bg-navy-primary">
      <div className="sr-only" role="navigation" aria-label="Skip links">
        <a 
          href="#main-content" 
          className="skip-link focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:px-4 focus:py-2 focus:bg-gold-primary focus:text-navy-primary focus:font-medium"
        >
          Skip to main content
        </a>
      </div>

      <TopNavBar 
        user={user}
        currentRole={currentRole}
        onRoleChange={handleRoleChange}
      />
      
      <main id="main-content" className="pt-[70px]" role="main" aria-label="Main content area">
        <Routes>
          <Route path="/" element={<CommandCenter currentRole={currentRole} />} />
          <Route path="/fleet" element={<Fleet currentRole={currentRole} />} />
          <Route path="/otto" element={<IframeModule moduleName="Otto" url="https://otto.afnai.com" accentColor="#3B82F6" />} />
          <Route path="/ally" element={<IframeModule moduleName="Ally" url={`https://ally.afnai.com?sso_email=${encodeURIComponent(user.email)}&sso_name=${encodeURIComponent(user.name)}`} accentColor="#10B981" />} />
          <Route path="/kronos" element={<IframeModule moduleName="Kronos" url="https://kronos.afnai.com" accentColor="#A855F7" />} />
          <Route path="/foundation" element={<ComingSoon module="Foundation" />} />
          <Route path="/analytics" element={<ComingSoon module="Analytics" />} />
          <Route path="/channels" element={<ComingSoon module="Channels" />} />
          <Route path="/admin" element={<ComingSoon module="Admin" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
